export default import.meta.ROLLDOWN_FILE_URL_0e0oc4MSW5tEjp58TrfHeg